import axios from 'axios';

export const FETCH_RESULTS = 'FETCH_RESULTS';
export const SEARCH_FILTER = 'SEARCH_FILTER';
export const ACTIVE_SEARCH = 'ACTIVE_SEARCH';
export const HEADER_SEARCH_TERM = 'HEADER_SEARCH_TERM';
export const SEARCH_CHANGE_NUMBER = 'SEARCH_CHANGE_NUMBER';

export function searchSite( s = '' ) {
	return ( dispatch ) => {
		if ( '' === s ) {
			dispatch( {
				          type: FETCH_RESULTS, payload: []
			          } );
		} else {
			const url = `${wpApiSettings.root}isda/v1/megamenu-search?s=${s}`;
			axios.get( url ).then( response => {
				dispatch( {
					          type: FETCH_RESULTS, payload: response.data
				          } );
			} );
		}
	};
}

export function makeStatusInActive() {
	return ( dispatch ) => {
		dispatch( {
			          type: ACTIVE_SEARCH, payload: false
		          } );
		dispatch( {
			          type: HEADER_SEARCH_TERM, payload: ''
		          } );
	};
}

export function makeStatusActive() {
	return ( dispatch ) => {
		dispatch( {
			          type: ACTIVE_SEARCH, payload: true
		          } );
	};
}

export function handleSearch( searchTerm ) {
	return ( dispatch ) => {
		dispatch( {
			          type: HEADER_SEARCH_TERM, payload: searchTerm
		          } );
	};
}

export function changeNumberDispatch( changeNumber ) {
	return ( dispatch ) => {
		dispatch( {
			          type: SEARCH_CHANGE_NUMBER, payload: changeNumber
		          } );
	};
}